/**
 * Shared column Tailwind classes for the IntakeForms list table.
 *
 * SCSS source: IntakeForms.scss → .if-col, .if-col-icon, .if-col-name, .if-col-arrow
 *
 * Both IntakeFormsTableBody (header row) and IntakeFormsTableItem (data rows)
 * import this single map so their column widths always stay aligned. The list shows only
 * Name + chevron (the admin endpoint returns no Service / Responses data), so those columns
 * were removed.
 *
 * SCSS → Tailwind token mapping:
 *   .if-col        flex items-center overflow-hidden flex-shrink-0
 *                  → 'flex items-center overflow-hidden shrink-0'
 *   .if-col-icon   flex: 0 0 40px  → 'shrink-0 w-sp-5'         (sp-5 = 40px)
 *   .if-col-name   flex: 1 1 0     → 'flex-1 min-w-0'
 *   .if-col-arrow  flex: 0 0 32px + justify-content: flex-end
 *                  → 'shrink-0 w-sp-4 justify-end'              (sp-4 = 32px)
 */
export const IF_COL = {
  base: 'flex items-center overflow-hidden shrink-0',
  icon: 'shrink-0 w-sp-5',
  name: 'flex-1 min-w-0',
  arrow: 'shrink-0 w-sp-4 justify-end',
} as const
